import type {
	ApproveResult,
	AuditStatus,
	CompletePriorTasksResult,
} from '../../redux/api/traveler-audit';

export type ApproveRow = ApproveResult['results'][number];

export const RECOVERABLE: AuditStatus[] = ['fail', 'review'];

export const isRecoverable = (status: AuditStatus) =>
	RECOVERABLE.includes(status);

export const splitPriorTaskRefusals = (rows: ApproveRow[]) => {
	const isPrior = (r: ApproveRow) =>
		r.refusal_code === 'prior_tasks_incomplete';
	return {
		prior: rows.filter((r) => !r.ok && isPrior(r)),
		other: rows.filter((r) => !isPrior(r)),
	};
};

export const splitPriorTaskResults = (rows: CompletePriorTasksResult[]) => {
	const done = rows.filter((r) => r.ok);
	return {
		done,
		ready: done.filter((r) => r.status === 'pass').length,
		needsRecovery: done
			.filter((r) => r.status && isRecoverable(r.status))
			.map((r) => r.id),
	};
};
